import { useState } from 'react'

import { MANAGEMENT_QUERY_KEY_SEARCH_SIM_TYPES, useManagementSearchSimTypes } from '@apps-common/apis/management/sim-type'
import { SimTypeModal } from '@apps-common/apps/portal/pages/management/components/sim-type'
import { ButtonRoundSm } from '@apps-common/components/elements'
import { Table } from '@apps-common/components/elements/table'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { queryClient } from '@apps-common/lib'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'

interface IProps {
  searchVal: string
}

export const SimTypeTableView: React.FC<IProps> = ({ searchVal }) => {
  const [skip, setSkip] = useState<number>(0)
  const [take, setTake] = useState<number>(10)
  const { isLoading, isError, data } = useManagementSearchSimTypes({
    search: searchVal
  })

  const keys = [
    {
      title: 'Sim Type',
      key: 'simTypeName',
      thClasses: '',
      tdClasses: ''
    },
    {
      title: 'Default',
      key: 'defaultItem',
      thClasses: '',
      tdClasses: '',
      Component: (props: any) => (
        <span>
          {props.defaultItem ? (
            <commonIcons.checkCircle className='text-[1.5em] bg-success rounded-full text-on-success p-[2px]' />
          ) : (
            <commonIcons.close className='text-[1.5em] bg-surface-2 rounded-full text-text p-[2px]' />
          )}
        </span>
      )
    },
    {
      title: 'Actions',
      key: 'actions',
      static: true,
      thClasses: 'text-right ',
      tdClasses: '',
      Component: (props: any) => (
        <div className='flex items-center justify-end gap-[5px]'>
          <ModalButton
            component={SimTypeModal}
            componentProps={{
              simTypeId: props.simTypeId
            }}
            confirmCallback={() => {
              queryClient.refetchQueries({ queryKey: MANAGEMENT_QUERY_KEY_SEARCH_SIM_TYPES(searchVal) })
            }}
            enterAnimation={modalSlideUpEnterAnimation}
            leaveAnimation={modalSlideUpLeaveAnimation}
          >
            <ButtonRoundSm type='div' className='action-brand-solid'>
              <commonIcons.arrowAngled />
            </ButtonRoundSm>
          </ModalButton>
        </div>
      )
    }
  ]

  const loading = isLoading || isError || !data

  return (
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[65px] sm:pt-[25px]'>
        <Table
          loading={loading}
          loadingSkeletonHeight='leading-[30px]'
          placeholderSkeletonHeight='leading-[30px]'
          pagination={{
            loading,
            count: data?.length || 0,
            skip,
            take,
            onSkipChanged: (value: number) => setSkip(value),
            onTakeChanged: (value: number) => setTake(value)
          }}
          keys={keys}
          data={data?.map((c) => ({ ...c, companies: data })) || []}
          sliceData
          topLeftComponent={
            <>
              {!loading && data && (
                <div className='jost-light'>
                  <span className='jost-medium'>{data?.length}</span> sim type results
                </div>
              )}
              {(loading || !data) && <div className='h-[22px] w-[100px] bg-skeleton rounded-lg' />}
            </>
          }
          onSkipChanged={(value: number) => setSkip(value)}
          onTakeChanged={(value: number) => setTake(value)}
        />
      </LayoutPadding>
    </LayoutContainer>
  )
}
